import { useQuery } from '@tanstack/react-query';
import { fetchInvoiceByRequest, fetchMyInvoices } from './api';

const INVOICES_KEY = ['invoices'] as const;

// retry: false — a 404 here just means no invoice exists yet (e.g. the auto-create-on-DELIVERED
// job hasn't finished), not a transient error worth retrying.
export function useInvoiceByRequest(requestId: string, enabled = true) {
  return useQuery({
    queryKey: [...INVOICES_KEY, 'request', requestId],
    queryFn: () => fetchInvoiceByRequest(requestId),
    enabled: enabled && !!requestId,
    retry: false,
  });
}

export function useMyInvoices(params: { page?: number; limit?: number } = {}) {
  return useQuery({
    queryKey: [...INVOICES_KEY, 'mine', params.page, params.limit],
    queryFn: () => fetchMyInvoices(params),
  });
}
